module.exports = __webpack_public_path__ + "static/media/vertiente-de-agua.a7e9e409.jpg";